import { createQueryPreloader } from '@apollo/client';

import { USER_CART } from '@api/operations/queries/Cart.gql';
import { client } from '@hooks/useApolloClient';
import { STORAGE_KEYS } from '@src/setup/dictionary';
import { getStorageItem } from '@utils/helperFunctions';

export const getInitialCart = () => {
  const cart = getStorageItem(STORAGE_KEYS.CART);
  return cart ?? undefined;
};

export const getInitialWishlist = () => {
  const userWishlist = sessionStorage.getItem('userWishlist');
  return userWishlist ? JSON.parse(userWishlist) : [];
};

export const preloadedCartRef = () => {
  const preload = createQueryPreloader(client);
  return preload(USER_CART);
};

// console.log('On completre data', data);
// const updatedCart = cache.readQuery({
//   query: USER_CART
// });
// update(updatedCart.cart as WebCarts);
